import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  microFrontEnds: [
    {
      remoteEntry: 'https://payments-panel.ci.eshopworld.net/v2/dist/remoteEntry.js',
      remoteName: 'paymentPanel',
      exposedModule: './PaymentPanelModule',
      rel: 'paymentPanel',
      moduleId: 'default',
      type: 'script'
    }
  ],
  fraudBootstrapScriptUrl: 'https://payments-panel.ci.eshopworld.net/js/fraudbootstrap.min.js',
  paymentsPanelApiUrl: 'https://payments-panel.ci.eshopworld.net',
  composableApiUrl: 'https://api.ci.esw.com',
  feroot: {
    bundleId: '#{ferootBundleId}',
    enabled: true
  },
  appInsights: 'f7d1789c-83bb-4384-9c9a-a25f83701a38'
};
